/**
 * This file holds computed state properties
 * Please refer to https://vuex.vuejs.org/guide/getters.html for more information
 */

const getters = {
  getOriginalImageId(state) {
    return ({ activeComponent }) => {
      const originalImage = state.storageController?.recipe?.components[activeComponent]?.ugc?.original_image?.image_id;
      if (!originalImage) return false;
      return originalImage;
    }
  },
  getOriginalImage(state) {
    return ({ activeComponent }) => {
      const originalImage = state.storageController?.recipe?.components[activeComponent]?.ugc?.original_image.image_url;
      if (!originalImage) return false;
      return originalImage;
    }
  },
  getStorageRecipeComponent(state) {
    return ({ activeComponent }) => {
      const recipeComponent = state.storageController.recipe?.components?.[activeComponent];
      if (!recipeComponent ||
        !recipeComponent.hasOwnProperty('subgroup') ||
        recipeComponent?.subgroup !== 'library' ||
        !recipeComponent.hasOwnProperty('ugc')
      ) return false;
      return recipeComponent;
    }
  },
  getStorageRecipe(state) {
    if (!state.storageController.recipe) return false;
    return state.storageController.recipe;
  },
  /**
   * Gets storage recipe formatted as in ugc/storageController recipes to work seamless with buyPanel flow
   */
  getStorageRecipeForBuyPanel(state, getters) {
    return ({ activeComponent, bucketSize, ugcObject }) => {
      let bucketRecipe = {};
      bucketRecipe[activeComponent] = ugcObject;
      return {
        [bucketSize]: bucketRecipe
      }
    }
  },
  isSecondComponentFlow(state, getters, rootState, rootGetters) {
    const secondaryComponent = rootGetters["ugc/getUGCComponentNotActive"];
    const imageLibraryCreated = state.selectedImages && state.selectedImages.hasOwnProperty(secondaryComponent);
    return secondaryComponent && imageLibraryCreated || state.secondComponentFlow;
  },
};

export default getters;
